import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'egl-header-button',
    templateUrl: './header-button.component.html',
    styleUrls: ['./header-button.component.scss'],
})
export class HeaderButtonComponent {
    @Input() label: string;
    @Input() icon: string;
}
